import React, { useEffect, useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Divider from "@mui/material/Divider";
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import GoalButton from "layouts/goals/components/GoalButton";
import FeatureTree, { FeatureCheckbox } from "./FeatureTree";
import { FEATURES, ORGANIZATIONS_MESSAGES, hasAllFeatures } from "../organizations.constants";

// Which features an organization has. "All features" also covers features added
// to the portal later; picking individual ones fixes the list.
function FeaturesModal({ open, onClose, onSave, isSubmitting, organization }) {
  const [all, setAll] = useState(true);
  const [selected, setSelected] = useState([]);
  const [localError, setLocalError] = useState(null);

  useEffect(() => {
    const everything = hasAllFeatures(organization?.features);
    setAll(everything);
    setSelected(everything ? FEATURES.map((feature) => feature.key) : organization.features);
    setLocalError(null);
  }, [organization, open]);

  const handleSave = async () => {
    if (!all && selected.length === 0) {
      return setLocalError(ORGANIZATIONS_MESSAGES.featuresRequired);
    }
    setLocalError(null);
    await onSave(organization.id, all ? ["*"] : selected);
  };

  return (
    <Dialog open={open} onClose={() => !isSubmitting && onClose()} fullWidth maxWidth="xs">
      <DialogTitle sx={{ fontSize: 18 }}>Features · {organization?.name}</DialogTitle>
      <DialogContent sx={{ pt: 0 }}>
        <SuiTypography variant="caption" color="text" display="block" mb={1.5}>
          A role can only use what its organization has, even a Super Admin.
        </SuiTypography>
        {localError && (
          <SuiTypography variant="caption" color="error" display="block" mb={1}>
            {localError}
          </SuiTypography>
        )}
        <FeatureCheckbox
          bold
          label="All features"
          checked={all}
          onChange={(e) => setAll(e.target.checked)}
        />
        <Divider sx={{ my: 1 }} />
        <FeatureTree
          selected={all ? FEATURES.map((feature) => feature.key) : selected}
          onChange={setSelected}
          disabled={all}
        />
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <GoalButton variant="secondary" onClick={onClose} disabled={isSubmitting}>
          Cancel
        </GoalButton>
        <GoalButton variant="primary" icon="save" loading={isSubmitting} onClick={handleSave}>
          Save features
        </GoalButton>
      </DialogActions>
    </Dialog>
  );
}

export default FeaturesModal;
